import { Theme } from '@mui/material/styles'

// ==============================|| OVERRIDES - ALERT TITLE ||============================== //

export default function Accordion(theme: Theme) {
  return {
    MuiAccordion: {
      defaultProps: {
        sx: {},
      },
      styleOverrides: {
        root: {
          '& .MuiButtonBase-root': {
            padding: '0px',
          },
        },
      },
    },
    MuiAccordionSummary: {
      defaultProps: {
        sx: {},
      },
      styleOverrides: {
        root: {
          '& .MuiAccordionSummary-content': {
            margin: '0px !important',
            alignItems: 'center',
          },
          minHeight: '0px !important',
        },
      },
    },
  }
}
